import patch from './patch';

/**
 * Toggle global menu visibility.
 */
export default () => (dispatch, getState) => {
  dispatch(patch({
    ui: { isGlobalMenuVisible: !getState().ui.isGlobalMenuVisible },
  }));
};
